function initPasswordToggles(root = document) {
    root.querySelectorAll('[data-password-toggle]').forEach((button) => {
        const inputId = button.getAttribute('aria-controls');
        const input = inputId ? root.querySelector(`#${CSS.escape(inputId)}`) : null;
        if (!input) return;

        button.addEventListener('click', () => {
            const isVisible = input.type === 'text';
            input.type = isVisible ? 'password' : 'text';
            button.textContent = isVisible ? '表示' : '非表示';
            button.setAttribute('aria-pressed', String(!isVisible));
        });
    });
}

function initAuthForms(root = document) {
    root.querySelectorAll('[data-auth-form]').forEach((form) => {
        const error = form.querySelector('[data-auth-client-error]');
        const password = form.querySelector('input[name="password"]');
        const confirmation = form.querySelector('input[name="password_confirmation"]');

        const showError = (message, input = null) => {
            if (!error) return;
            if (!error.id) error.id = 'auth-client-error';
            error.textContent = message;
            error.hidden = false;
            if (input instanceof HTMLElement) {
                input.setAttribute('aria-invalid', 'true');
                input.setAttribute('aria-errormessage', error.id);
            }
        };

        form.addEventListener('submit', (event) => {
            error?.setAttribute('hidden', 'hidden');
            form.querySelectorAll('[aria-invalid="true"]').forEach((input) => {
                input.removeAttribute('aria-invalid');
                input.removeAttribute('aria-errormessage');
            });
            if (!form.checkValidity()) {
                event.preventDefault();
                form.reportValidity();
                return;
            }
            if (password && confirmation && password.value !== confirmation.value) {
                event.preventDefault();
                showError('新しいパスワードと確認用パスワードが一致しません。', confirmation);
                confirmation.focus();
            }
        });
    });
}

export function initAuthPages(root = document) {
    if (!root?.querySelector) return;
    initPasswordToggles(root);
    initAuthForms(root);
}
